document.addEventListener("DOMContentLoaded", function () {
	// --- DOM Elements ---
	const steps = document.querySelectorAll(".funnel-step-content");
	const sidebar = document.getElementById("funnel-sidebar");
	const nav = document.getElementById("funnel-bottom-nav");
	const modal = document.getElementById("funnel_details_modal_id");
	const btnMobile = document.getElementById("funnel-details-btn");
	const btnDesktop = document.getElementById("funnel-details-btn-desktop");
	const translations = FoxTheme.custom_made_funnel;

	// --- Navigation ---
	const stepNumber = 7;
	let stepsCompleted = false;

	// Show/hide sidebar and sticky nav depending on step
	function updateSidebarVisibility() {
		const summaryStep = steps[stepNumber];
		if (summaryStep && summaryStep.style.display !== "none") {
			sidebar.style.display = "none";
		} else {
			sidebar.style.display = "";
			// Only show sticky nav if on mobile and not summary
			if (nav && window.matchMedia("(max-width: 768px)").matches) nav.style.display = "";
		}

		// GTM funnel tracking
		steps.forEach((step, index) => {
			if (step.style.display !== "none") {
				const labels = document.querySelectorAll(`label.selected`);
				labels.forEach((label) => {
					let labelInput = label.querySelector("input");

					if (!window._funnelPublishedChoices) window._funnelPublishedChoices = new Set();
					const choiceKey = `${labelInput.name}:${labelInput.value}`;
					if (!window._funnelPublishedChoices.has(choiceKey)) {
						Shopify.analytics.publish("custom_demi_mesure_steps", {
							event: "select_content",
							event_category: "custom made funnel",
							event_action: labelInput.name,
							event_label: labelInput.value,
						});
						window._funnelPublishedChoices.add(choiceKey);
					}

					const nextBtnMobile = document.getElementById("funnel-next-btn-mobile");
					const completed = index == stepNumber;
					stepsCompleted = completed;
					nextBtnMobile.disabled = completed;
					nextBtnMobile.classList.toggle("disabled", completed);
					nextBtnMobile.setAttribute("aria-disabled", completed);
				});
			}
		});
	}

	// Observe step changes to update sidebar/nav
	const observer = new MutationObserver(updateSidebarVisibility);
	steps.forEach((step) => {
		observer.observe(step, { attributes: true, attributeFilter: ["style", "class"] });
	});
	updateSidebarVisibility();

	// --- Sticky Navigation for Mobile ---

	// Sync state between desktop and mobile nav buttons
	function syncMobileNavState() {
		const nextBtn = document.getElementById("funnel-next-btn");
		const prevBtn = document.getElementById("funnel-prev-btn");
		let nextBtnMobile = document.getElementById("funnel-next-btn-mobile");
		let prevBtnMobile = document.getElementById("funnel-prev-btn-mobile");
		if (!nextBtn || !prevBtn || !nextBtnMobile || !prevBtnMobile) return;

		nextBtnMobile.disabled = nextBtn.disabled;
		prevBtnMobile.disabled = prevBtn.disabled;
		nextBtnMobile.classList.toggle("disabled", nextBtn.disabled);
		prevBtnMobile.classList.toggle("disabled", prevBtn.disabled);
		nextBtnMobile.setAttribute("aria-disabled", nextBtn.disabled);
		prevBtnMobile.setAttribute("aria-disabled", prevBtn.disabled);
	}

	// Handle sticky nav visibility and button sync for mobile/desktop
	function handleStickyNav() {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const summaryStep = steps[stepNumber];
		let nextBtn = document.getElementById("funnel-next-btn");
		let prevBtn = document.getElementById("funnel-prev-btn");
		let nextBtnMobile = document.getElementById("funnel-next-btn-mobile");
		let prevBtnMobile = document.getElementById("funnel-prev-btn-mobile");

		if (nav && summaryStep && summaryStep.style.display !== "none") {
			nav.style.display = "none";
			return;
		}
		if (!nav || !nextBtn || !prevBtn || !nextBtnMobile || !prevBtnMobile) return;

		if (isMobile) {
			nav.style.display = "";
			nextBtn.style.display = "none";
			prevBtn.style.display = "none";

			// Store and restore disabled state after replacing nodes
			const nextDisabled = nextBtn.disabled;
			const prevDisabled = prevBtn.disabled;
			nextBtnMobile.outerHTML = nextBtnMobile.outerHTML;
			prevBtnMobile.outerHTML = prevBtnMobile.outerHTML;
			nextBtnMobile = document.getElementById("funnel-next-btn-mobile");
			prevBtnMobile = document.getElementById("funnel-prev-btn-mobile");
			nextBtnMobile.disabled = nextDisabled;
			prevBtnMobile.disabled = prevDisabled;
			nextBtnMobile.classList.toggle("disabled", nextDisabled);
			prevBtnMobile.classList.toggle("disabled", prevDisabled);
			nextBtnMobile.setAttribute("aria-disabled", nextDisabled);
			prevBtnMobile.setAttribute("aria-disabled", prevDisabled);

			nextBtnMobile.addEventListener("click", function (e) {
				e.preventDefault();
				if (!nextBtn.disabled) nextBtn.click();
			});
			prevBtnMobile.addEventListener("click", function (e) {
				e.preventDefault();
				if (!prevBtn.disabled) prevBtn.click();
			});
		} else {
			nav.style.display = "none";
			nextBtn.style.display = "";
			prevBtn.style.display = "";
		}
	}

	window.addEventListener("resize", handleStickyNav);
	document.addEventListener("change", syncMobileNavState);
	handleStickyNav();

	// --- Modal Logic ---

	// Open the details modal and update its content for mobile
	function openDetailsModal() {
		if (!modal) return;
		modal.setAttribute("open", "");

		// For mobile, update the details content
		if (window.matchMedia("(max-width: 768px)").matches) {
			const fields = ["material", "shape", "color", "ribbon", "bow", "veil", "size"];
			fields.forEach((field) => {
				const detailsStepValueEl = document.querySelector(`.details-step-value[data-step-field="${field}"]`);
				if (!detailsStepValueEl) return;
				const detailsStep = detailsStepValueEl.closest(".details-step");
				if (!detailsStep) return;

				const labelEl = detailsStep.querySelector(".details-step-label");
				const dotEl = detailsStep.querySelector(".details-dot");
				const valueEl = detailsStepValueEl;

				const checked = document.querySelector(`input[name="${field}"]:checked`);
				const hasValue = checked && checked.value;

				// Special handling for ribbon (gros_grain)
				if (field === "ribbon" && hasValue) {
					const mainColor = document.querySelector('input[name="ribbon_color_main"]:checked');
					const secondColor = document.querySelector('input[name="ribbon_color_second"]:checked');
					if (checked.value.trim().toUpperCase() === "DOUBLE") {
						valueEl.innerHTML =
							translations.type +
							" : " +
							checked.value +
							"; <br>" +
							translations.mainColor +
							" : " +
							(mainColor ? mainColor.value : "-") +
							"; <br>" +
							translations.secondaryColor +
							" : " +
							(secondColor ? secondColor.value : "-");
					} else {
						valueEl.innerHTML =
							translations.type + " : " + checked.value + "; <br>" + translations.mainColor + " : " + (mainColor ? mainColor.value : "-");
					}
				} else {
					valueEl.textContent = hasValue ? checked.value : translations.none;
				}

				// Visual feedback for completed/incomplete steps
				if (hasValue) {
					detailsStep.classList.add("completed");
					if (labelEl) labelEl.style.color = "#000";
					valueEl.style.color = "#000";
					if (dotEl) dotEl.style.background = "#000";
				} else {
					detailsStep.classList.remove("completed");
					if (labelEl) labelEl.style.color = "#bbb";
					valueEl.style.color = "#bbb";
					if (dotEl) dotEl.style.background = "#eee";
				}
			});
		}
	}

	// Close the details modal
	function closeDetailsModal() {
		if (!modal) return;
		modal.removeAttribute("open");
	}

	// Attach open handlers to both mobile and desktop buttons
	if (btnMobile) btnMobile.addEventListener("click", openDetailsModal);
	if (btnDesktop) btnDesktop.addEventListener("click", openDetailsModal);

	// Handle modal close via close button or overlay click
	document.addEventListener(
		"click",
		function (e) {
			if (!modal || !modal.hasAttribute("open")) return;

			const actualCloseButton = modal.querySelector(".drawer__close-btn");
			if (actualCloseButton && (actualCloseButton === e.target || actualCloseButton.contains(e.target))) {
				e.stopPropagation();
				closeDetailsModal();
				return;
			}

			const actualOverlay = modal.querySelector(".fixed-overlay");
			if (actualOverlay && actualOverlay === e.target) {
				e.stopPropagation();
				closeDetailsModal();
				return;
			}
		},
		true
	);

	// Allow closing modal with ESC key
	document.addEventListener("keydown", function (e) {
		if (e.key === "Escape" && modal && modal.hasAttribute("open")) {
			closeDetailsModal();
		}
	});
});
